export const TAXES_HELP_CENTER_ARTICLE_ID = '4411577966227';
export const PREVIOUS_YEAR_TAX_REPORTING_REQUIREMENTS_ARTICLE_ID = '4411577966227';
export const UPCOMING_YEAR_TAX_REPORTING_REQUIREMENTS_ARTICLE_ID = '12763053152531';
